<template>
<loader v-bind="{ loading }">
  <page-navigation :title="`${team.name}`">
    <template #right>
       <router-link
        class="button"
        :to="{
          name: 'team-invite-user',
          params: {
            team: team.id
          }
        }">Invite a User</router-link>
    </template>
  </page-navigation>

  <p class="title is-4">Apps ({{ team.apps.length }})</p>
  <div class="box">
    <columns v-for="app in team.apps" :key="app.id">
      <column>
        <p>{{ app.name }}</p>
      </column>
      <column class="is-narrow">
        <icon @click="removeApp(app)" class="has-text-danger pointer" icon="trash"/>
      </column>
    </columns>
  </div>
  
  <p class="title is-4">Members ({{ activeMembers.length }})</p>
  <div class="box">
    <team-member :member="member" :permissions="permissions" v-for="member in activeMembers" :key="member.id"/>
    <no-items-to-show v-if="!activeMembers.length" text="No Team Members Found">
      <router-link
        :to="{ name: 'team-invite-user' }"
        class="is-rounded button">
        <icon icon="plus"/>
        <span>Invite a User</span>
      </router-link>
    </no-items-to-show>
  </div>
</loader>  
</template>
<script>
import { mapGetters } from 'vuex'
import TeamMember from './partials/TeamMember'
import { get } from '@/api/request'

export default {

  components: {
    TeamMember
  },
  
  data: () => ({
    loading: true,
    permissions: []
  }),

  beforeCreate() {
    Promise.all([
      this.$store.dispatch('team/loadTeam', this.$route.params.team).then(team => {
        this.$bus.$emit('set-title', `Teams • ${team.name}`)
      }),
      get('api/team-permissions', ({data}) => this.permissions = data)
    ]).then(() => this.loading = false)
  },

  methods: {
    async removeApp(app) {
      if(await this.$confirm({
        title: 'Remove App from Team',
        message: `Are you sure you want to remove ${app.name} from this team?`
      })) {

      }
    }
  },

  computed: {
    ...mapGetters('team', [
      'team'
    ]),
    activeMembers() {
      return this.team.members.filter(member => member.accepted_at != null)
    }
  }

}
</script>